<template>
  <font-awesome-icon
    icon="calendar-week"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendarWeek } from '@fortawesome/free-solid-svg-icons'

library.add(faCalendarWeek)

export default {
  name: 'CoozzyCalendarWeekIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
